module.exports = __webpack_public_path__ + "static/media/pol_bg_3.c59788b5.webp";